import axios from 'axios'
import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()
const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})
export default instance

let getAcc = ''
let getRef = ''
let headers = ''

// eslint-disable-next-line consistent-return
export async function chekcAccTest() {
  getAcc = cookies.get('access_token')
  getRef = cookies.get('refresh_token')
  // headers = { Authorization: getAcc }
  try {
    if (getAcc) {
      // access_token이 있는 상황 ==> 로그인을 한 상황
      // "MB23000200" -> 유효기간 내
      headers = { Authorization: getAcc }
      const chkAT = await instance.get(`/api/v1/member/token`, { headers })
      console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
      console.log('chekcAccT 함수 내부')
      console.log('chkAT ::: ', chkAT)
      console.log('chkAT.data >>> ', chkAT.data)
      console.log('chkAT.data.code :>>: ', chkAT.data.code) // "MB23000200" etc
      console.log('로그인 상태, auth.js 페이지임.')
      console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
      return chkAT.data.code
      // eslint-disable-next-line no-else-return
    } else {
      const loginStatus = 'notYet'
      console.log('미로그인, auth.js 페이지임.')
      return loginStatus
    }
  } catch (error) {
    // "MB23000200" -> 유효기간 내
    console.log('try-catch로 잠시 바꿈')
    console.log('error ::: ', error)
    console.log('error.response.data ::: ', error.response.data)
    console.log(
      'error.response.data.status_code ::: ',
      error.response.data.status_code
    ) // 404
    console.log('error.response.data.code ::: ', error.response.data.code) // 4040011
    return error.response.data.code
  }
}

export async function testAxiosGet() {
  getAcc = cookies.get('access_token')
  getRef = cookies.get('refresh_token')

  if (getAcc) {
    headers = { Authorization: getAcc }
    await instance
      .get('/api/v1/member/token', { headers })
      .then((response) => {
        const codeData = response.data.code
        console.log(
          'testAxiosGet에서 codeData를 401에러 if문 만나기 전부터 찍어보기 ::: ',
          codeData
        )
        // console.log(codeData)
        if (codeData === 'AU4010001') {
          instance.post('/api/v1/member/auth/token', { refesch_token: getRef })
        } else {
          // MB23000200 정상 로그인 코드
          console.log('complet')
        }
      })
      .catch((error) => {
        console.log('error ::: ', error)
        console.log('error.response ::: ', error.response)
        console.log('error.response.data ::: ', error.response.data)
        console.log(
          'error.response.data.status_code ::: ',
          error.response.data.status_code
        )
        // eslint-disable-next-line no-use-before-define
        // checkValidity(error.response.data.status_code)
      })
  } else {
    console.log('uncomp')
  }
}

// eslint-disable-next-line consistent-return
export async function checkValidity(status) {
  try {
    console.log('checkValidity로 들어온 status값을 찍어보자 :::: ', status)
    // console.log(status)
    if (status === 400) {
      // eslint-disable-next-line prettier/prettier
      const renewData = { refresh_token: getRef }
      const renewRes = await instance.post(
        `/api/v1/member/auth/token`,
        renewData
      )
      getAcc = cookies.set('access_token', renewRes.data.content.access_token)
      // eslint-disable-next-line prettier/prettier
      headers = { Authorization: getAcc }
      await instance.get(`/api/v1/member/token`, { headers })
    } else if (status === 404) {
      getAcc = cookies.get('access_token')
      getRef = cookies.get('refresh_token')
      headers = { Authorization: getAcc }
      try {
        await instance.post(`/api/v1/member/logout`, null, { headers })
        localStorage.clear()
        cookies.remove('access_token')
        cookies.remove('refresh_token')
        cookies.remove('stayToken')
        window.location.href = '/'
      } catch (err) {
        localStorage.clear()
        cookies.remove('access_token')
        cookies.remove('refresh_token')
        cookies.remove('stayToken')
        window.location.href = '/'
      }
      return status
    }
  } catch (err) {
    console.log(err)
  }
}

export async function loadContentsList() {
  const pageIndex = 1
  const pageSize = 10
  // eslint-disable-next-line prettier/prettier
  const params = { cfc_name: '', title: '' }

  const contentsRes = await instance.get(
    `/api/v1/lecture/intro/contents?page_size=${pageSize}&page_index=${pageIndex}`,
    params
  )
  // console.log(contentsRes);
  // let contentList = contentsRes.data.content
  // console.log(contentList);
  // eslint-disable-next-line no-unused-expressions
  contentsRes.data.content
  return contentsRes.data
}
